let trackAnalyticsAction = (category, action, label, nonInteraction = 1) => {
	ga('send', 'event', category, action, label, {'nonInteraction': nonInteraction})
}

export {
	trackAnalyticsAction
}

